import type { DriverProfileRow } from '@routeback/core';
import type { AppState } from '../../lib/app';

/** Digits only, for comparing and for tel: links. */
export const digits = (s: string): string => s.replace(/\D/g, '');

/** "6305550100" → "630-555-0100" (US 10-digit; anything else is left as typed). */
export function formatPhone(s: string): string {
  const d = digits(s);
  const ten = d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
  return ten.length === 10 ? `${ten.slice(0, 3)}-${ten.slice(3, 6)}-${ten.slice(6)}` : s.trim();
}

/** A phone that's present but clearly not a full number. */
export const badPhone = (s: string): boolean => !!s.trim() && digits(s).length < 10;

/**
 * Update my profile in this company, creating it the first time. Reads the
 * stored row at save time so quick edits never make a second profile (the
 * server allows one per person per company).
 */
export async function saveMyProfile(app: AppState, patch: Partial<Pick<DriverProfileRow, 'phone' | 'emergency_name' | 'emergency_phone' | 'sizes'>>): Promise<DriverProfileRow> {
  const current = (await app.db.table<DriverProfileRow, string>('driver_profiles').where('company_id').equals(app.company.id).toArray())
    .find((p) => !p.deleted_at && p.user_id === app.userId);
  if (current) return app.repos.driverProfiles.save({ ...current, ...patch });
  return app.repos.driverProfiles.save(app.repos.driverProfiles.blank({ user_id: app.userId, phone: '', emergency_name: '', emergency_phone: '', sizes: {}, ...patch }));
}
